import type { ReactNode } from 'react';
import { Footer } from '@/modules/home/components/Footer';
import { PublicHeader } from '@/components/Layout/PublicHeader';
import { PublicPageBackdrop } from '@/components/Layout/PublicPageBackdrop';

interface PublicLayoutProps {
  children: ReactNode;
}

export const PublicLayout = ({ children }: PublicLayoutProps) => {
  return (
    <div className="relative min-h-screen flex flex-col">
      <PublicPageBackdrop variant="default" />
      <div className="relative z-10 flex min-h-screen flex-col">
        <PublicHeader />
        <main className="flex-1">{children}</main>
        <Footer />
      </div>
    </div>
  );
};
